import React, { useEffect, useState } from "react";
import {
  Box,
  SubHeadingStyled,
  TabsList,
  ThemeLoader,
} from "../../../components/styled/Elements";
import { RequestWrapper } from "./styled";
import { useTranslation } from "react-i18next";
import { requestsTabs } from "../../../helpers/adminConstants/AdminConstants";
import RequestsApi from "../../../services/api/requestsApi";
import { PlaceholderImg } from "../../../components/styled/AllImages";
import { getFormattedDate } from "../../../utils";
import { toast } from "react-toastify";
import echo from "../../../echo";
import { useUser } from "../../../context/userContext";

const Requests = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { user } = useUser();
  const userId = Number(user?.id);
  const initialTab =
    requestsTabs.find(
      (tab) => tab.title === window.location.hash.replace("#", "")
    ) || requestsTabs[0];
  const [activeTab, setActiveTab] = useState(initialTab);
  const [activePage, setActivePage] = useState(1);
  const [totalCount, setTotalCount] = useState(null);
  const [perPage, setPerPage] = useState(null);
  const [receivedReqsRows, setReceivedReqsRows] = useState([]);
  const [isLoadingRequests, setIsLoadingRequests] = useState(false);
  const [sentReqsRows, setSentReqsRows] = useState([]);
  const ASSET_URL = process.env.REACT_APP_ASSET_URL;

  const handleTabChange = (tabIndex) => {
    setActiveTab(requestsTabs[tabIndex]);
    setActivePage(1);
  };

  useEffect(() => {
    window.location.hash = activeTab.title;
  }, [activeTab]);

  const getRequestsList = async (page = 1, typeId) => {
    try {
      setIsLoadingRequests(true);
      const { data, code } = await RequestsApi.getRequestsList(page, typeId);
      if (code === 200) {
        if (typeId === 1) {
          const formattedData = data?.list?.map((item) => {
            const getInfoData = (item) => {
              const baseData = {
                cabinetName:
                  item.module_parent_detail?.cabinet_name?.name || null,
              };

              switch (Number(item.module_id)) {
                case 1:
                  return [
                    {
                      title: t("cabinet_name"),
                      value: item.module_name,
                    },
                    {
                      title: t("cabinet_id"),
                      value: item.module_reference_number,
                    },
                  ];

                case 2:
                  return [
                    {
                      title: t("cabinet_name"),
                      value: item.module_parent_detail.name,
                    },
                    {
                      title: t("file_name"),
                      value: item.module_name,
                    },
                    {
                      title: t("file_id"),
                      value: item.module_reference_number,
                    },
                  ];

                case 3:
                  return [
                    {
                      title: t("cabinet_name"),
                      value: baseData.cabinetName,
                    },
                    {
                      title: t("file_name"),
                      value: item.module_parent_detail?.name || null,
                    },
                    {
                      title: t("archive_name"),
                      value: item.module_name,
                    },
                    {
                      title: t("archive_id"),
                      value: item.module_reference_number,
                    },
                  ];

                default:
                  return [];
              }
            };
            return {
              id: item.id,
              status: item.status,
              requester: {
                name: item.user.name,
                subLabel: `${item.user.department} (${item.user.location})`,
                avatar: item.user.profile
                  ? `${ASSET_URL}/${item.user.profile}`
                  : PlaceholderImg,
              },
              accessRequestedFor: {
                utilityName: item.module_name,
                infoData: getInfoData(item),
              },
              decision: item.decision,
              closeDate: item.decision_time
                ? getFormattedDate(item.decision_time)
                : null,
              reason: item?.reject_decision_reason,
            };
          });
          setReceivedReqsRows(formattedData);
          setTotalCount(data?.pagination?.total);
          setPerPage(data?.pagination?.per_page);
        } else {
          const formattedData = data?.list?.map((item) => {
            const getInfoData = (item) => {
              const baseData = {
                cabinetName:
                  item.module_parent_detail?.cabinet_name?.name || null,
              };

              switch (Number(item.module_id)) {
                case 1:
                  return [
                    {
                      title: t("cabinet_name"),
                      value: item.module_name,
                    },
                    {
                      title: t("cabinet_id"),
                      value: item.module_reference_number,
                    },
                  ];

                case 2:
                  return [
                    {
                      title: t("cabinet_name"),
                      value: item.module_parent_detail.name,
                    },
                    {
                      title: t("file_name"),
                      value: item.module_name,
                    },
                    {
                      title: t("file_id"),
                      value: item.module_reference_number,
                    },
                  ];

                case 3:
                  return [
                    {
                      title: t("cabinet_name"),
                      value: baseData.cabinetName,
                    },
                    {
                      title: t("file_name"),
                      value: item.module_parent_detail?.name || null,
                    },
                    {
                      title: t("archive_name"),
                      value: item.module_name,
                    },
                    {
                      title: t("archive_id"),
                      value: item.module_reference_number,
                    },
                  ];

                default:
                  return [];
              }
            };

            return {
              id: item.id,
              status: item.status,
              benefactor: {
                name: item.user.name,
                subLabel: `${item.user.department} (${item.user.location})`,
                avatar: item.user.profile
                  ? `${ASSET_URL}/${item.user.profile}`
                  : PlaceholderImg,
              },
              accessRequestedFor: {
                utilityName: item.module_name,
                infoData: getInfoData(item),
              },
              decision: item.decision,
              closeDate: item.decision_time
                ? getFormattedDate(item.decision_time)
                : null,
              reason: item?.reject_decision_reason,
            };
          });

          setSentReqsRows(formattedData);
          setTotalCount(data?.pagination?.total);
          setPerPage(data?.pagination?.per_page);
        }
      } else {
        setReceivedReqsRows([]);
        setSentReqsRows([]);
        setTotalCount(null);
        setPerPage(null);
      }
    } catch (error) {
      return error;
    } finally {
      setIsLoadingRequests(false);
    }
  };

  const acceptRejectRequest = async (requestId, decision, reason) => {
    const formData = new FormData();
    formData.append("request_id", requestId);
    formData.append("decision", decision);
    reason && formData.append("reject_decision_reason", reason);
    try {
      // setIsLoadingRequests(true);
      const { code, message } = await RequestsApi.acceptRejectRequest(formData);
      if (code === 200) {
        getRequestsList(activePage, activeTab?.id);
        if (decision == 1) {
          toast.success(t("request_approved"));
        } else if (decision == 2) {
          toast.success(t("request_rejected"));
        } else if (decision == 0) {
          toast.success(t("request_cancelled"));
        }
      }
      if (code === 100) toast.error(t(message));
    } catch (error) {
      return error;
    } finally {
      // setIsLoadingRequests(false)
    }
  };

  useEffect(() => {
    getRequestsList(activePage, activeTab?.id);
  }, [activePage, activeTab, language]);

  useEffect(() => {
    getRequestsList(activePage, 2);
  }, [])

  useEffect(() => {
    const channel = echo.channel("cloud-archive");
    channel.listen(".request-updated", (event) => {
      if (
        Array.isArray(event) &&
        event.length > 0 &&
        event
          .filter((e) => Number(e.to_user_id) === userId)
          .some((e) => Number(e.to_user_id) === userId)
      ) {
        getRequestsList(activePage, activeTab?.id);
      }
    });

    return () => {
      echo.leaveChannel("cloud-archive");
    };
  }, []);

  return (
    <RequestWrapper>
      <Box className="content-head">
        <SubHeadingStyled size="18px" weight="700" color="var(--text)">
          {t("requests")}
        </SubHeadingStyled>
      </Box>
      <Box>
        <TabsList
          sentRequestsCount={
            sentReqsRows && sentReqsRows?.length > 0
              ? sentReqsRows?.length
              : null
          }
          receivedRequestsCount={
            receivedReqsRows && receivedReqsRows?.length > 0
              ? receivedReqsRows?.length
              : null
          }
          tabs={requestsTabs}
          activeTab={activeTab}
          handleTabChange={handleTabChange}
        />
      </Box>
      <Box>
        {isLoadingRequests ? (
          <ThemeLoader />
        ) : (
          <activeTab.component
            receivedReqsRows={receivedReqsRows}
            setReceivedReqsRows={setReceivedReqsRows}
            sentReqsRows={sentReqsRows}
            totalCount={totalCount}
            perPage={perPage}
            activePage={activePage}
            setActivePage={setActivePage}
            acceptRejectRequest={acceptRejectRequest}
          />
        )}
      </Box>
    </RequestWrapper>
  );
};

export default Requests;
